import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import Modal from "../../../Components/Modal";
import { terugstoren } from "../Reducers/actions";
import Terugstortform from "./terugstortform";
import { message, fixmessage } from "../../../Reducers/loading/actions";
import { connect } from "react-redux";

const TerugstortModal = ({ terugstoren, visible, close, boeking, message, fixmessage }) => {
  const submit = (values) => {
    const vals = {
      bedrag: values.bedrag,
      beschrijving: values.beschrijving,
      id: boeking._id,
    };
    terugstoren(vals).then((data) => {
      if (data.type === "ERROR_BOEKINGEN") {
        if (data.payload.error && data.payload.error.msg) {
            message(3000, "danger", data.payload.error.msg);
        } else {
             message(3000, "danger",  "De boeking is niet succesvol verwerkt");
        }
      } else {
        message(3000, "success", "De boeking is succesvol verwerkt").then(() => {
          close(false);
        });
      }
    });
  };

  return createPortal(
    <Modal
      visible={visible}
      onClose={() => {
        close(false);
      }}
      width={600}
    >
      <div className="card actionmodal">
        <div className="card-header">
          <h4 className="mb-0">Terugstoren bedrag</h4>
        </div>
        <div className="card-body">
          <Terugstortform boeking={boeking} onSubmit={submit} />
        </div>
      </div>
    </Modal>,
    document.body
  );
};

function mapStateToProps(state) {
  return { username: state.auth.user, boekingen: state.boekingen.items };
}

export default connect(mapStateToProps, { terugstoren, message, fixmessage })(TerugstortModal);
